import HousingReport from './components/HousingReport';

function App() {
  return <HousingReport />;
}

export default App;